export const PENDING_STATE = '_pending';
export const PENDING_STACK = 'stack';
export const PENDING_INDEX = 'index';
